/** Shared query key (used by react-query to know when to refresh pref data) */
export const QUERY_KEY_MY_SETTINGS = 'preferences';
